export const mapToList = (map) => {
  return Array.from(map).map(([value, name]) => {
    return {
      name,
      value,
    };
  });
};
